var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.rm.PortfolioName) +
                        " / " +
                        _vm._s(_vm.rm.ScenarioName)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Plan: Approval")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [
                    _c("PortfolioScenarioNavigation", {
                      attrs: {
                        portfolioId: _vm.rm.PortfolioId,
                        corporateScenarioUrl: _vm.rm.CorporateScenarioUrl,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-light navbar-expand-md mt-5",
                  staticStyle: {
                    "background-color": "rgba(0, 0, 0, 0.03)",
                    border: "1px solid rgba(0, 0, 0, 0.125)",
                    "border-bottom": "0",
                  },
                  attrs: { role: "navigation" },
                },
                [
                  _c("ul", { staticClass: "navbar-nav" }, [
                    _c("li", { staticClass: "dropdown mr-2" }, [
                      _c("div", { staticClass: "navbar-form" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-success",
                            attrs: { type: "button" },
                            on: { click: _vm.handleApproveScenarioCommand },
                          },
                          [
                            _c("i", { staticClass: "fa-solid fa-pen-nib" }),
                            _vm._v(" Approve all\n                        "),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "navbar-nav ml-auto mr-2" }, [
                    _c("li", { staticClass: "dropdown" }, [
                      _c("div", { staticClass: "navbar-form" }, [
                        _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary dropdown-toggle",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v("View: " + _vm._s(_vm.filter))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    _vm.filter = "All"
                                  },
                                },
                              },
                              [_vm._v("All")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c("h6", { staticClass: "dropdown-header" }, [
                              _vm._v("Filter by status:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    _vm.filter = "TBD"
                                  },
                                },
                              },
                              [_vm._v("TBD")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    _vm.filter = "Accepted"
                                  },
                                },
                              },
                              [_vm._v("Accepted")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    _vm.filter = "Rejected"
                                  },
                                },
                              },
                              [_vm._v("Rejected")]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form-inline my-2 my-lg-0",
                      attrs: { role: "search" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                          },
                        ],
                        staticClass: "form-control mr-sm-2",
                        attrs: { type: "search", placeholder: "Search" },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.projectsView, function (a) {
                    return _c("tr", { key: a.Id }, [
                      _c("td", [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/alternative/dashboard/${_vm.workspaceId}/${_vm.tchProjectId}/${a.Id}`,
                                expression:
                                  "`/#/alternative/dashboard/${workspaceId}/${tchProjectId}/${a.Id}`",
                              },
                            ],
                            staticClass: "text-primary",
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(a.Name) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        a.HasActivePlan
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/q/project/pnl/${_vm.workspaceId}/${_vm.tchProjectId}/${a.Id}/${a.ActivePlanId}`,
                                    expression:
                                      "`/#/q/project/pnl/${workspaceId}/${tchProjectId}/${a.Id}/${a.ActivePlanId}`",
                                  },
                                ],
                                staticClass: "text-primary",
                              },
                              [
                                _vm._v(
                                  "\n                            View\n                        "
                                ),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/q/project/summary/${_vm.workspaceId}/${_vm.tchProjectId}/${a.Id}`,
                                    expression:
                                      "`/#/q/project/summary/${workspaceId}/${tchProjectId}/${a.Id}`",
                                  },
                                ],
                                staticClass: "text-danger",
                              },
                              [
                                _vm._v(
                                  "\n                            NA\n                        "
                                ),
                              ]
                            ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(a.Acceptance))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "table-warning":
                              a.ScenarioStartDateString !==
                              a.PortfolioStartDateString,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(a.ScenarioStartDateString)
                          ),
                          _c("br"),
                          _vm._v(" "),
                          a.PortfolioStartDateString
                            ? _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                            (" +
                                    _vm._s(a.PortfolioStartDateString) +
                                    ")\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "table-warning":
                              a.ScenarioCommitmentStartDateString !==
                              a.PortfolioCommitmentStartDateString,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(a.ScenarioCommitmentStartDateString)
                          ),
                          _c("br"),
                          _vm._v(" "),
                          a.PortfolioCommitmentStartDateString
                            ? _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                            (" +
                                    _vm._s(
                                      a.PortfolioCommitmentStartDateString
                                    ) +
                                    ")\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          class: {
                            "table-warning":
                              a.ScenarioKanbanStatus !==
                              a.PortfolioKanbanStatus,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(a.ScenarioKanbanStatus)
                          ),
                          _c("br"),
                          _vm._v(" "),
                          a.PortfolioKanbanStatus
                            ? _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                            (" +
                                    _vm._s(a.PortfolioKanbanStatus) +
                                    ")\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        a.IsApproved === false
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-success",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleApproveScenarioProjectCommand(
                                      a.Id
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Approve\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        a.IsApproved === true
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { disabled: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleApproveScenarioProjectCommand(
                                      a.Id
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Approved\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Project")]),
        _vm._v(" "),
        _c("th", [_vm._v("P&L")]),
        _vm._v(" "),
        _c("th", [_vm._v("Acceptance")]),
        _vm._v(" "),
        _c("th", [_vm._v("Start date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Commitment date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }